import { ApiErrorResponse, ApiResponse } from 'apisauce';

import { getErrorMessage } from '@api/network';

export const getAssistantErrorMessage = (response: ApiErrorResponse<any> | ApiResponse<any, any>): string => {
  const data = response.data;

  if (typeof data?.detail === 'string') {
    return data.detail;
  }

  if (Array.isArray(data?.detail)) {
    return data.detail
      .map((item: { msg?: string } | string) => (typeof item === 'string' ? item : item.msg || String(item)))
      .join(', ');
  }

  return getErrorMessage(response as ApiErrorResponse<any>) || 'Something went wrong. Please try again.';
};
